module.exports = __webpack_public_path__ + "static/media/yellowParrot.e2a85371.png";